/**
 * Mirrors `IdeonMappedCarrier` from partner-benefit-graph
 * `src/app/ideon/utils/carrier-name-mapping.ts` — the set of carrier
 * integrations the platform actually supports for Ideon agent identifiers.
 */
export const CARRIER_INTEGRATIONS = ['centene', 'hcsc'] as const

export type CarrierIntegration = (typeof CARRIER_INTEGRATIONS)[number]

export const carrierIntegrationOptions: Array<{
  value: CarrierIntegration
  label: string
}> = [
  { value: 'centene', label: 'Centene' },
  { value: 'hcsc', label: 'HCSC' },
]

const carrierLabelByValue = new Map(
  carrierIntegrationOptions.map((o) => [o.value, o.label] as const)
)

export const formatCarrierIntegrationLabel = (code?: string): string =>
  (code && carrierLabelByValue.get(code as CarrierIntegration)) || code || '—'
